import { LoadingActionI, CHANGE_LOADING_STATUS } from '../action/loading';

const initialState = false;

const LoadingReducer = (
  state: boolean = initialState,
  action: LoadingActionI,
) => {
  return action.type === CHANGE_LOADING_STATUS
    ? action.payload.value
    : initialState;
};

export default LoadingReducer;
